@if (!authState().isAuthenticated) {
@defer {
<pixl-login></pixl-login>
} @placeholder {
Lade Anwendung
} @loading (minimum 2s) {
<div class="spinner-overlay">
    <div class="spinner-overlay-content">
        <pixl-spinner></pixl-spinner>
    </div>
</div>
}
} @else if (authState().isAuthenticated) {
@if (spinnerService.showSpinner$()) {
<div class="spinner-overlay">
    <div class="spinner-overlay-content">
        <pixl-spinner></pixl-spinner>
    </div>
</div>
}

<mat-sidenav-container class="sidenav-container">
    <!-- Navigation -->
    <mat-sidenav
        #drawer
        class="sidenav-left"
        fixedInViewport
        [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="(isHandset$ | async) === false"
    >
        <a
            class="app-title"
            routerLink="/"
            [attr.aria-label]="title"
        >
            <div class="logo"></div>
        </a>
        <pixl-sidenav-menu />
    </mat-sidenav>

    <!-- ROUTER OUTLET -->
    <mat-sidenav-content>
        <mat-toolbar color="primary">
            <!--
      @if (isHandset$ | async) {
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      }
      -->
            <div class="nav-breadcrumb">
                <button
                    type="button"
                    aria-label="Toggle sidenav"
                    mat-icon-button
                    (click)="drawer.toggle(); fullMenu.set(!fullMenu())"
                    title="{{ getBurgerButtonTitle() }}"
                    [ngStyle]="{ cursor: fullMenu() ? 'zoom-out' : 'zoom-in' }"
                >
                    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
                </button>
                &nbsp;
                <pixl-breadcrumb />
            </div>

            <span class="spacer"></span>
            <mat-menu #userMenu="matMenu">
                <button
                    mat-menu-item
                    (click)="setup()"
                ><mat-icon matMenuItemIcon>settings</mat-icon> Einstellungen</button>
                <button
                    mat-menu-item
                    (click)="about()"
                ><mat-icon matMenuItemIcon>info</mat-icon> Über...</button>
                <button
                    mat-menu-item
                    (click)="logout()"
                ><mat-icon matMenuItemIcon>logout</mat-icon> Logout</button>
            </mat-menu>
            <button
                mat-button
                [matMenuTriggerFor]="userMenu"
                class="user-button"
            >
                <mat-icon aria-hidden="true">face</mat-icon>
                {{ authState().editor?.email }}
            </button>
        </mat-toolbar>
        <div class="page-content">
            <router-outlet />
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
}